import React from "react";

import {
    FaArrowDown,
    FaArrowUp,
} from "react-icons/fa";

import {
    formatPercentage,
    getGrowthType,
} from "../utils/dashboardFormatters";


const MetricCard = ({
    title,
    value,
    icon: Icon,
    subtitle,
    growth,
    emphasis = false,
    onClick,
}) => {

    const growthType =
        getGrowthType(
            growth
        );


    return (

        <div
            className={
                `dashboard-metric-card ${
                    emphasis
                        ? "dashboard-metric-card--emphasis"
                        : ""
                } ${
                    onClick
                        ? "dashboard-metric-card--clickable"
                        : ""
                }`
            }

            onClick={
                onClick
            }

            role={
                onClick
                    ? "button"
                    : undefined
            }
        >

            <div
                className="dashboard-metric-top"
            >

                <div
                    className="dashboard-metric-icon"
                >
                    {Icon && (
                        <Icon />
                    )}
                </div>


                {
                    growth !==
                    undefined &&
                    growth !==
                    null && (

                        <div
                            className={
                                `dashboard-growth dashboard-growth--${growthType}`
                            }
                        >

                            {
                                growthType ===
                                "positive" && (
                                    <FaArrowUp />
                                )
                            }


                            {
                                growthType ===
                                "negative" && (
                                    <FaArrowDown />
                                )
                            }


                            <span>
                                {
                                    formatPercentage(
                                        growth
                                    )
                                }
                            </span>

                        </div>
                    )
                }

            </div>


            <div
                className="dashboard-metric-content"
            >

                <span
                    className="dashboard-metric-title"
                >
                    {title}
                </span>


                <strong
                    className="dashboard-metric-value"
                >
                    {value}
                </strong>


                {
                    subtitle && (

                        <small
                            className="dashboard-metric-subtitle"
                        >
                            {subtitle}
                        </small>
                    )
                }

            </div>

        </div>
    );
};


export default MetricCard;